import datamethods from './datamethods.js'
import {mapFields} from 'vuex-map-fields'
export default{
    mixins:[datamethods],
    computed:{
        ...mapFields([
            'loggedInUser',
            'applicationMode',
            'securityAppName',
            'tutorialItems',
            'tutorialIndex',
            'tutorialMaxIndex',
            'inTutorial',
            'tutorialFirstStep',
            'tutorialLastStep',
            'showTutorial',
            'tutorialIdSet'
        ]),
        currentTutorialStep(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].id
        },
        currentTutorialStepName(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].name
        },
        currentTutorialStepDescription(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].description
        },
         currentTutorialStepUrl(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].url
        },
        currentTutorialStepElementName(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].uiElementName
        },
        tutorialScreenLocation(){
            if(this.tutorialItems.length==0){return 'main'}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return 'main'}
            return this.tutorialItems[this.tutorialIndex-1].screenLocation
        },
        tutorialExists(){
            return this.tutorialItems.length>0
        },
        allowLocationSelection(){
            return this.applicationMode=='Full'
        },
    },
    data(){
        return{
            
        }
    },
    methods:{
        async getApplicationMode(){
            let req = {
                ID:this.loggedInUser.LocationId
            }
            //call api
            var response = await this.callAPI(req,'applicationmode')
            //handle response
            if(response.Successful){
              this.applicationMode=response.StringResponse  
              console.log('application mode ' + this.applicationMode)
              if(this.applicationMode=='Trial' && !this.inTutorial){
                    this.tutorialStart()
              }
            }else{
              this.responseMessage = response.Message
            }
           
        },

        async getTutorial(){
            let req = {
                tutorialName:this.securityAppName
            }
            //call api
            var response = await this.callAPI(req,'tutorial')
            //handle response
            if(response.Successful){
              this.tutorialItems=response.tutorialItems  
              this.tutorialFirstStep = response.firstStepIndex
              this.tutorialLastStep=response.lastStepIndex
              this.tutorialInitializeData()
            }else{
              this.responseMessage = response.Message
            }
           
        },
        tutorialInitializeData(){
            //add id's to set
            var mythis=this
            this.tutorialItems.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let t=arr[index]
                mythis.tutorialIdSet.add(t.uiElementName)
            }

            //add listener
            document.addEventListener('click',this.handleElementClicks)

            this.inTutorial=true

            this.tutorialShow()
            this.tutorialIndex=0
            this.tutorialMaxIndex=this.tutorialItems.length
            
            this.setHighlight()
        },
        handleElementClicks(event){
            if (this.tutorialIdSet.has(event.target.id)) {
                console.log('Clicked tutorial element:', event.target.id);
                this.tutorialNext()
            }
        },
        tutorialHide(){
            this.showTutorial=false
            this.removeHighlight()
        },
        tutorialShow(){
            this.showTutorial=true
            this.setHighlight()
        },
        
        tutorialNext(){

            if(this.tutorialIndex<=this.tutorialMaxIndex){
                this.removeHighlight()
                this.tutorialIndex=Number(this.tutorialIndex) + 1
                if(this.tutorialIndex<=this.tutorialMaxIndex){
                    if(this.showTutorial){this.setHighlight()}
                }else{
                    this.tutorialDone() //auto done
                }
            }
        },
        tutorialPrevious(){
            if(this.tutorialIndex>1){
                this.removeHighlight()
                this.tutorialIndex=Number(this.tutorialIndex) - 1
                this.setHighlight()
            }else{
                this.tutorialBackOut() //auto done
            }
        },
        setHighlight(){
           
            console.log('sethighlight ' + this.currentTutorialStepElementName)
            var el =document.getElementById(this.currentTutorialStepElementName)
            if(el!=undefined){
                el.classList.add("highlightelement")
            }

            this.$nextTick(()=>{
                this.moveTutorialBoxToElement()
            })
        },
        removeHighlight(){
            console.log('removehighlight ' + this.currentTutorialStepElementName)
            var el =document.getElementById(this.currentTutorialStepElementName)
            if(el!=undefined){
                el.classList.remove("highlightelement")
            }
            
        },
        moveTutorialBoxToElement(){
            let el =document.getElementById(this.currentTutorialStepElementName)
            let tutorialpopup = document.getElementById('tutorialpopup')

             if (!el || !tutorialpopup) return

            const rect = el.getBoundingClientRect()

            tutorialpopup.style.position = 'absolute'
            tutorialpopup.style.left = `${rect.right}px`
            tutorialpopup.style.top = `${rect.bottom}px`

        },
        tutorialStart(){
            this.getTutorial()
        },
        tutorialEnd(){
            this.removeHighlight()
            this.inTutorial=false

            //clean up listener
            document.removeEventListener('click',this.handleElementClicks)
        },

        //tutorial done: the admin home/parent version
        async tutorialDone(){
            console.log('parent tutorial done!!')

           //tell parent to show message!
           console.log('before emit msg')
            await this.$emit('tutorialmessage')
            console.log('after emit msg')
            this.tutorialEnd()

            //tell the kids
            this.sendMessage_AllChildApps('tutorialend')
        },
        tutorialBackOut(){
            console.log('tutorial back out parent')
            this.removeHighlight()
            this.tutorialIndex=0
            
        }
        //tutuorial done: the child version
        /* tutorialDone(){
            this.tutorialEnd()
            
            //tell the parent app
            const message = JSON.stringify({
                to:'AdminHome',
                id:0,
                action:'tutorialdone_child'
            })
            window.parent.postMessage(message, '*')
        } */
      /*  tutorialBackOut(){
            console.log('tutorial back out child')
            this.tutorialEnd()
            
            //tell the parent app
            const message = JSON.stringify({
                to:'AdminHome',
                id:0,
                action:'tutorialback_child'
            })
            window.parent.postMessage(message, '*')
        } */
    }

}